import { FetchModelResponse } from '@cian/http-api';

import type { IV2GetOfferCalendarResponseSchema } from 'shared/repositories/dailyrent/entities/response/V2GetOfferCalendarResponseSchema';
import type { IErrorResponseSchema } from 'shared/repositories/dailyrent/entities/schemas/ErrorResponseSchema';
import { IGetOfferCalendarMappedResponse200 } from 'shared/services/fetchGetOfferCalendar/types';
import { TDaysAvailability } from 'shared/types/bookingCalendar';

export const mapCalendarResponse = (
  response: IV2GetOfferCalendarResponseSchema,
): IGetOfferCalendarMappedResponse200 => {
  const mappedCalendar = response.calendar.split('').map(Number) as TDaysAvailability;

  return {
    statusCode: 200,
    response: { calendar: mappedCalendar },
  };
};

export const mapCalendarResponseError = (
  response: IErrorResponseSchema,
): FetchModelResponse<400, 'json', IErrorResponseSchema> => {
  return {
    statusCode: 400,
    response: {
      errors: response.errors,
      message: response.message,
    },
  };
};
